import { useSelector } from 'react-redux'
import {
  Action,
  Entity,
  CrudAction,
  BlendingGranularAction,
  DeliveryGranularAction,
  SilosGranularAction,
  WheatCodeGranularAction,
} from '../../types/permissions'
import { hasPermission, selectCompanyRoles, selectPermissions } from 'store'

const usePermissions = () => {
  const permissions = useSelector(selectPermissions)

  /**
   * Check if user has permission for a specific entity and action
   */
  const checkPermission = (entity: Entity, action: Action): boolean => {
    return hasPermission(permissions, entity, action)
  }

  /**
   * Check if user has CRUD permission for a specific entity
   */
  const checkCrudPermission = (entity: Entity, action: CrudAction): boolean => {
    return checkPermission(entity, action)
  }

  /**
   * Check if user has any of the specified permissions for an entity
   */
  const checkAnyPermission = (entity: Entity, actions: Action[]): boolean => {
    return actions.some((action) => checkPermission(entity, action))
  }

  /**
   * Check if user has all the specified permissions for an entity
   */
  const checkAllPermissions = (entity: Entity, actions: Action[]): boolean => {
    return actions.every((action) => checkPermission(entity, action))
  }

  return {
    checkPermission,
    checkCrudPermission,
    checkAnyPermission,
    checkAllPermissions,
  }
}

export { usePermissions, Entity, CrudAction }

export type {
  Action,
  BlendingGranularAction,
  DeliveryGranularAction,
  SilosGranularAction,
  WheatCodeGranularAction,
}
